import { Link } from "react-router-dom";
import type { TimelineVisit } from "@/lib/visits";

/** Under a visit on a timeline: the photo taken there (if any) and a link to the visit's GPS details */
export function VisitTimelineExtra({ visit, label }: { visit?: TimelineVisit | null; label?: string }) {
  if (!visit) return null;
  return (
    <div className="mt-1.5 flex items-end gap-3">
      {visit.has_photo && (
        <a href={`/api/FieldVisit/Photo/${visit.visit_id}`} target="_blank" rel="noreferrer" className="block shrink-0 overflow-hidden rounded-md border border-border">
          <img src={`/api/FieldVisit/Photo/${visit.visit_id}`} alt={label ? `At ${label}` : "Visit photo"} loading="lazy" className="h-20 w-28 object-cover" />
        </a>
      )}
      <Link to={`/visits?id=${visit.visit_id}`} className="text-xs font-medium text-primary hover:underline">
        Visit details and location
      </Link>
    </div>
  );
}
